import { LabMDM } from "./lab";
import { OperetionHistoryDTO } from "./operationHistory";
import { SalesItemTypeConfig } from "./salesitemtype-config";

//this model is used to define the product details

export class Product{
    _id: string;
    /** The name of the product. */
    name:string;

	/** stores if the boolean value is active or not */
    active:boolean;

    /** stores List of Sales Item Types */
    salesItemType:SalesItemTypeConfig[];

    workflow:string;

    /** lab associated with the product */
    lab:LabMDM;
    
    premixed:boolean; 

    requiredRead:number;

    tagSystem:string;

    snpProfile: string;

    history:OperetionHistoryDTO[];
}